import { render, staticRenderFns } from "./proxyAudit.vue?vue&type=template&id=b6a5084e&scoped=true&"
import script from "./proxyAudit.vue?vue&type=script&lang=js&"
export * from "./proxyAudit.vue?vue&type=script&lang=js&"
import style0 from "./proxyAudit.vue?vue&type=style&index=0&id=b6a5084e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5084e",
  null
  
)

export default component.exports